export enum EndOfDayPaymentMethodMergeMode {
  NONE = "NONE",
  CARD_TERMINALS = "CARD_TERMINALS",
  ALL_BUT_OTHER = "ALL_BUT_OTHER",
  ALL = "ALL",
}
